import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@common-fe/common-fe';

import { useProvideNameVisible } from '@/modules/core';

import { useGeneralInfoStore } from '../PersonalInformation/GeneralInfo/stores';
import Statements from '../Statements';
import TaxForms from '../TaxForms';

import LettersOfMedicalNecessity from './components/LettersOfMedicalNecessity/LettersOfMedicalNecessity';
import MyDocumentsHeader from './components/MyDocumentsHeader';
import Receipts from './components/Receipts/Receipts';
import useReceiptsFeatureFlag from './hooks/useReceiptsFeatureFlag';
import { MyDocumentsTabs } from './myDocuments.types';

import useMyDocumentsTabStore from './stores/useMyDocumentsTab.store';

const MyDocuments = () => {
  const { isReceiptsEnabled } = useReceiptsFeatureFlag();
  const { employeeId } = useGeneralInfoStore((state) => state.state);
  const isProviderNameVisible = useProvideNameVisible();
  const defaultTab = useMemo(() => {
    if (!isProviderNameVisible) {
      return MyDocumentsTabs.TAX_FORMS;
    }
    const availableTab = isReceiptsEnabled ? MyDocumentsTabs.RECEIPTS : MyDocumentsTabs.LMN;
    return availableTab;
  }, [isProviderNameVisible, isReceiptsEnabled]);

  const [tab, setTab] = useState<string>(defaultTab);
  const pendingTab = useMyDocumentsTabStore((state) => state.pendingTab);
  const setPendingTab = useMyDocumentsTabStore((state) => state.setPendingTab);

  useEffect(() => {
    if (pendingTab) {
      setTab(pendingTab);
      setPendingTab(null);
    }
  }, [pendingTab, setPendingTab]);

  useEffect(() => {
    if (!isProviderNameVisible) {
      if (tab !== MyDocumentsTabs.TAX_FORMS) {
        setTab(MyDocumentsTabs.TAX_FORMS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProviderNameVisible]);

  return (
    <Box data-testId="my-documents-page" margin={{ bottom: 'spacing24' }}>
      <MyDocumentsHeader tab={tab} setTab={setTab} />
      <Box margin={{ top: 'spacing24' }} data-testId="my-documents-page_tab-wrapper">
        {tab === MyDocumentsTabs.RECEIPTS ? <Receipts /> : null}
        {tab === MyDocumentsTabs.LMN ? <LettersOfMedicalNecessity /> : null}
        {tab === MyDocumentsTabs.STATEMENTS ? <Statements employeeId={employeeId} /> : null}
        {tab === MyDocumentsTabs.TAX_FORMS ? <TaxForms employeeId={employeeId} /> : null}
      </Box>
    </Box>
  );
};

export default MyDocuments;
